<div id="cxone-connect-3-game">
    <!-- Qualifier -->
    <div class="d-flex justify-content-start align-items-center mb-1">
        <cxone-game-qualifier *ngIf="game.Qualifier !== null" [game]="game" [ranking]="ranking" [gameStatus]="gameStatus" [checkTextTruncation]="checkTextTruncation"></cxone-game-qualifier>
    </div>
    <!-- Rewards -->
    <div class="d-flex justify-content-start align-items-center mb-2">
        <span class="text-regular" cvLocalizedText langSection="Games_Module" langKey="Rewards">Rewards</span><span
            class="text-regular">:&nbsp;</span>
        <span class="mr-1">
            <svg class="icon-16" style="margin-bottom: 3px;">
                <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
            </svg>
        </span>
        <span class="text-coin mr-3">{{ coins | cvNumberLocalize}}</span>
        <span>
            <svg class="icon-16" style="margin-bottom: 3px;">
                <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
            </svg>
        </span>
        <span class="ml-1">
            <img *ngIf="badge" [src]="'../Admin/ImageResizer.aspx?imgid=' + badge + '&w=24&h=24'">
        </span>
    </div>
    <!-- Container -->
    <div class="slots-container">
        <!-- Grid view -->
        <cxone-games-connect-3-slot *ngFor="let connect3Item of connect3Positions;"
            #connect3Slot
            [slotType]="getConnect3Class(connect3Item, game?.underlyingRule.GameType)"
            [tooltipTitle]="connect3Item.metric.abbrev"
            [tooltipTarget]="gs.formatterMetricData(connect3Item.metric.conversionType ,connect3Item.targetObj.Target)"
            [tooltipTargetDirection]="connect3Item.targetObj.Direction"></cxone-games-connect-3-slot>
    </div>
</div>
